if (typeof ga == 'function') { 
  $('#menu-main-navigation > li:first-child').on('mouseenter', function() {
    ga('send', 'event', 'Navigation', 'Open Nav');
  });

  $('#menu-main-navigation .block_type_mega_sub .sub-menu > li > a').click(function() {
    ga('send', 'event', 'Navigation', 'Top Level Category Click', $(this).text().trim());
  });

  $('#menu-mobile-nav .menu-item:first-child > .sub-menu-dropdown > .container > .sub-menu > li > a').click(function() {
    ga('send', 'event', 'Navigation', 'Top Level Category Click', $(this).text().trim());
  });

  $('#menu-main-navigation .block_type_mega_sub .sub-sub-menu a').click(function() {
    ga('send', 'event', 'Navigation', 'Subcategory Click', $(this).text().trim());
  });

  $('#menu-mobile-nav .menu-item:first-child > .sub-menu-dropdown .sub-menu-dropdown a').click(function() {
    console.log('Subcat', $(this).text().trim());
  });

  $('#menu-mobile-nav .menu-item:first-child .icon-sub-menu').click(function() {
    if ($(this).hasClass('up-icon')) return;
    ga('send', 'event', 'Navigation', 'Expand Dropdown', $(this).siblings('a').text().trim());
  });
}